import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { createMilitaryHistoryConflictField } from '../components/ConflictPageField';

const ConfirmMilitaryHistoryField = createMilitaryHistoryConflictField(
  'No conflicts were found between your uploaded documents and your military history information.',
);

export default {
  uiSchema: {
    ...titleUI(
      'Confirm Veteran military history',
      'The information you entered is different than what we detected in your documents. Review and confirm which information is correct.',
    ),
    militaryHistoryConflictData: {
      'ui:field': ConfirmMilitaryHistoryField,
    },
  },
  schema: {
    type: 'object',
    properties: {
      militaryHistoryConflictData: {
        type: 'object',
        properties: {},
      },
    },
  },
};
